import React from "react";
import { Link } from "react-router-dom";

function OrderSuccess() {
  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        
        {/* Success Icon */}
        <div style={iconCircle}>
          <span style={checkIcon}>✓</span>
        </div>
        
        <h2 style={titleStyle}>Order Placed Successfully!</h2>
        
        <p style={messageStyle}>
          Thank you for choosing Delight Store. Your order has been securely saved in our system.
        </p>

        {/* WhatsApp Explanation Box */}
        <div style={infoBox}>
          <p style={{ margin: 0, fontSize: "14px", color: "#555", lineHeight: "1.5" }}>
            <strong style={{ color: "#E65100" }}>What's Next?</strong><br/> 
            Please send the automated WhatsApp message that just opened. We will confirm your delivery details and dispatch your items shortly!
          </p>
        </div>

        <Link to="/" style={{ textDecoration: "none" }}>
          <button style={btnStyle}>Return to Shop</button>
        </Link>
        
      </div>
    </div>
  );
}

// ================= THEMATIC STYLES =================

const containerStyle = { 
  display: "flex", 
  justifyContent: "center", 
  alignItems: "center", 
  minHeight: "80vh", 
  padding: "20px", 
  background: "#FAFAFA", 
  fontFamily: "'Segoe UI', Roboto, sans-serif" 
};

const cardStyle = { 
  background: "#FFF", 
  padding: "40px 30px", 
  borderRadius: "16px", 
  textAlign: "center", 
  maxWidth: "420px", 
  boxShadow: "0 10px 30px rgba(0,0,0,0.05)", 
  border: "1px solid #E0E0E0" 
};

const iconCircle = { 
  width: "80px", 
  height: "80px", 
  background: "#E8F5E9", // Very light green 
  borderRadius: "50%", 
  display: "flex", 
  justifyContent: "center", 
  alignItems: "center", 
  margin: "0 auto 20px auto", 
  boxShadow: "0 4px 10px rgba(46, 125, 50, 0.1)" 
};

const checkIcon = { 
  color: "#2E7D32", // Trust Green
  fontSize: "45px", 
  fontWeight: "bold" 
};

const titleStyle = { 
  color: "#333", 
  marginBottom: "15px", 
  fontSize: "24px" 
};

const messageStyle = { 
  color: "#666", 
  lineHeight: "1.5", 
  marginBottom: "25px", 
  fontSize: "15px" 
};

const infoBox = { 
  background: "#FFF3E0", // Soft Peach/Marigold
  padding: "15px", 
  borderRadius: "8px", 
  borderLeft: "4px solid #F57C00", // Bold Marigold border
  textAlign: "left", 
  marginBottom: "30px" 
};

const btnStyle = { 
  background: "#F57C00", // Marigold Orange
  color: "#FFF", 
  border: "none", 
  padding: "14px 30px", 
  borderRadius: "25px", 
  fontSize: "16px", 
  fontWeight: "bold", 
  cursor: "pointer", 
  width: "100%", 
  boxShadow: "0 4px 12px rgba(245, 124, 0, 0.2)",
  transition: "0.2s"
};

export default OrderSuccess;